import { Action } from '../actions/vehicles';

const defaultState = {
  isFetching: false,
  isDismissingRecall: false,
  recallsByKey: {},
  error: undefined,
  dismissError: undefined,
};

export default function vehicleRecallsReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Vehicle.FetchVehicleRecallSearchResultsPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };
    case Action.Vehicle.FetchVehicleRecallSearchResultsCompleted:
      return {
        ...state,
        isFetching: false,
        recallsByKey: {
          ...(state.recallsByKey || {}),
          [body.recallKey]: body.recalls,
        },
      };
    case Action.Vehicle.FetchVehicleRecallSearchResultsFailed:
      return {
        ...state,
        isFetching: false,
        error: 'An error occurred fetching vehicle recalls. Please try again later.',
      };
    case Action.Vehicle.FetchUserVehicleRecallsPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };
    case Action.Vehicle.FetchUserVehicleRecallsCompleted:
      return {
        ...state,
        isFetching: false,
        recallsByKey: {
          ...(state.recallsByKey || {}),
          [body.guid]: { activeRecalls: body.activeRecalls, dismissedRecalls: body.dismissedRecalls },
        },
      };
    case Action.Vehicle.FetchUserVehicleRecallsFailed:
      return {
        ...state,
        isFetching: false,
        error: 'Error retrieving recalls for vehicle',
      };
    case Action.Vehicle.DismissUserVehicleRecallPending:
      return {
        ...state,
        dismissError: undefined,
        isDismissingRecall: true,
      };
    case Action.Vehicle.DismissUserVehicleRecallCompleted:
      return {
        ...state,
        isDismissingRecall: false,
        recallsByKey: {
          ...state.recallsByKey,
          [body.guid]: { activeRecalls: body.activeRecalls, dismissedRecalls: body.dismissedRecalls },
        },
      };
    case Action.Vehicle.DismissUserVehicleRecallFailed:
      return {
        ...state,
        isDismissingRecall: false,
        dismissError: 'Error dismissing vehicle recall',
      };

    default:
      return state;
  }
}
